exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".expectationPeriodPreference{position:relative}.expectationPeriodPreference .frequencyRadioBtn{margin-right:5px}.expectationPeriodPreference .inputFrequency{font-size:.8em;font-weight:400}.expectationPeriodPreference .periodStartSelector{font-size:.8em;padding-left:2rem}.expectationPeriodPreference .startDatePicker{margin-left:.5rem;margin-bottom:.7rem;width:9rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.expectationPeriodPreference .saveExpectationPeriod{position:absolute;bottom:0;left:70%;width:100%}.expectationPeriodPreference .disclaimer{font-size:90%;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/preferences/expectation_period_preference.scss
// module id = 1358
// module chunks = 0